module.exports = __webpack_public_path__ + "static/media/energetic_neutral.75481beb.svg";